export type BaseRouteParam = Record<string, unknown>;
export type ArticleRouteParam = BaseRouteParam & { id: string };
export type SectionRouteParam = BaseRouteParam & {
  level1: string;
  level2?: string;
};
export type RouteParam = BaseRouteParam | ArticleRouteParam | SectionRouteParam;

export enum Section {
  /** 首页，不是分类 */
  HOME = "home",
  /** 观点 */
  PERSPECTIVE = "perspective",
  /** 新闻 */
  OVERVIEW = "overview",
  /** 特写 */
  GOOD_READS = "good-reads",
  /** 视频 */
  VIDEOS = "videos",
}

/**
 * @description SectionDisplayTagMap is a map of section to display tag
 * @description Change English to Chinese
 */
export const SectionDisplayTagMap = {
  [Section.HOME]: "",
  [Section.PERSPECTIVE]: "观点",
  [Section.OVERVIEW]: "新闻",
  [Section.GOOD_READS]: "特写",
  [Section.VIDEOS]: "视频",
};

const realSections = [
  Section.PERSPECTIVE,
  Section.OVERVIEW,
  Section.GOOD_READS,
  Section.VIDEOS,
];

/**
 * @description check if the section is a real section, including 观点, 新闻, 特写, 视频
 */
export const isRealSection = (
  section: string,
): section is
  | Section.GOOD_READS
  | Section.PERSPECTIVE
  | Section.OVERVIEW
  | Section.VIDEOS => realSections.includes(section as Section);
